import { Link } from 'react-router-dom';

import { Typography } from 'antd';

import styled, { StyledProp } from '@/styled';

interface IProps extends StyledProp {
  title: string;
  total_lessons: number;
  to: string;
  target?: string;
}

const CourseDefaultCover = ({ title, total_lessons, ...rest }: IProps) => {
  return (
    <Link rel='noopener noreferrer' {...rest}>
      <Typography.Title className='defaultCover-title' level={4} ellipsis={{ rows: 4 }}>
        {title}
      </Typography.Title>
      <Typography.Paragraph className='defaultCover-lessonCountText' ellipsis>
        {total_lessons} Aulas
      </Typography.Paragraph>
    </Link>
  );
};

export default styled(CourseDefaultCover)`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-radius: ${({ theme }) => theme.borderRadius}px;
  background: ${({ theme }) => theme.palette.gray[8]};
  aspect-ratio: 9/16;
  cursor: pointer;
  padding: ${({ theme }) => theme.space.spacing(4)};

  .defaultCover-icon {
    font-size: ${({ theme }) => theme.space.pxToRem(48)};
    color: ${({ theme }) => theme.palette.gray[9]};
    margin-bottom: 16px;
  }

  .defaultCover-title {
    color: ${({ theme }) => theme.palette.gray[4]};
    font-weight: 500;
    text-align: center;
    margin-bottom: 4px;
  }

  .defaultCover-lessonCountText {
    font-weight: 400;
    color: ${({ theme }) => theme.palette.gray[6]};
  }
`;
